import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { CloseOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { fireCustomEvent } from '~helpers/custom-events';
import { PendingApproval as PendingApprovalIcon } from 'common/components/svgs';
import * as actions from '~actions/pms-actions/pending-approval';
import Draft from '~pages/pms-dashboard/properties/listing-management/pending-approval/list/draft';

const mapStateToProps = state => ({
  drafts: state.pmsReducer.dashboard.pendingApproval.toJS().drafts,
});

const mapDispatchToProps = dispatch => ({
  getPendingApprovalList: successCallback => {
    dispatch(actions.getPendingApprovalList(successCallback));
  },
});

@connect(mapStateToProps, mapDispatchToProps)
export default class PendingApprovalList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowList: false,
    };
  }

  componentDidMount() {
    this.props.getPendingApprovalList();
  }

  showList = () => {
    this.changeDashboardStyle();
    if (!this.state.isShowList) {
      fireCustomEvent('triggerCloseMenu');
    }

    this.setState({
      isShowList: !this.state.isShowList,
    });

    setTimeout(() => {
      fireCustomEvent('toggleCollapseSidebarTriggers');
    }, 300);
  };

  changeDashboardStyle = () => {
    const dashboardLayout = document.querySelector('.dashboard__layout');
    const propertyList = document.querySelector('.property-list');
    const propertyListContainer = document.querySelector('.property-list__list');

    if (dashboardLayout && propertyList && !this.state.isShowList) {
      propertyList.setAttribute('class', 'property-list property-list--small');
      if (propertyListContainer) {
        propertyListContainer.setAttribute('class', 'property-list__list');
      }
      dashboardLayout.style.minWidth = '1261px';
    } else if (dashboardLayout && propertyList) {
      propertyList.setAttribute('class', 'property-list');
      dashboardLayout.style.minWidth = '780px';
    }

    return true;
  };

  render() {
    const { t, drafts } = this.props;
    return (
      <React.Fragment>
        <div className="pending-approval__menu">
          <Choose>
            <When condition={!this.state.isShowList}>
              <Tooltip
                placement="left"
                arrowPointAtCenter
                title={t('cms:cms.properties.pending_approval.list.title')}
              >
                <button onClick={this.showList} className="pending-approval__list-btn">
                  <PendingApprovalIcon className="pending-approval__list-icon" />
                  <If condition={drafts.length > 0}>
                    <span className="pending-approval__red-dot" />
                  </If>
                </button>
              </Tooltip>
            </When>
            <Otherwise>
              <button
                onClick={this.showList}
                className="pending-approval__list-btn pending-approval__list-btn--click"
              >
                <PendingApprovalIcon className="pending-approval__list-icon" />
              </button>
            </Otherwise>
          </Choose>
        </div>
        <div
          className={classNames('pending-approval__list-wrap', {
            'pending-approval__list-wrap--open': this.state.isShowList,
          })}
        >
          <div className="pending-approval__header">
            <div className="pending-approval__title">
              {t('cms:cms.properties.pending_approval.list.title')}
            </div>
            <div className="pending-approval__count">
              {t('cms:cms.properties.pending_approval.list.text', {
                pendingApprovalTotal: drafts.length || 0,
              })}
            </div>
            <button className="pending-approval__close-btn" onClick={this.showList}>
              <CloseOutlined style={{ fontSize: '14px', color: '#9e9e9e' }} />
            </button>
          </div>
          <div>
            <For of={drafts} each="draft" index="index">
              <Draft key={index} t={t} draft={draft} history={this.props.history} />
            </For>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

PendingApprovalList.propTypes = {
  t: PropTypes.func.isRequired,
  drafts: PropTypes.array,
  history: PropTypes.object,
  getPendingApprovalList: PropTypes.func,
};

PendingApprovalList.defaultProps = {
  t: () => {},
  drafts: [],
  history: {},
  getPendingApprovalList: () => {},
};
